export enum DocumentCategoryLabel {
  PRODUCTION = 'Production',
  INTERVENTION = 'Intervention',
  DISPONIBILITY = 'Disponibilité',
  EXPLOITATION = 'Exploitation',
}

export enum DocumentType {
  PDF = 'pdf',
  XLSM = 'xlsm',
  XLSX = 'xlsx',
  DOCX = 'docx',
  KMZ = 'kmz',
  JPG = 'jpg',
  AUTRE = 'Autre',
}
